/* eslint-disable no-debugger */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
  DownloadOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import { Image, Skeleton, Space, Tooltip } from "antd";
import React, { useState } from "react";
import { heicToJpg } from "../../../../utils";
import { mediaDownloader } from "../../../../utils/mediaDownloader";
import KlipyWatermark from "../../../../icons/svg/klipy-watermark.svg";
import AudioPlayer from "../../../smai-calling/audioPlayer/audioComp";
import "./image.css";
import MediaViewer from "./mediaViewer";
import { PDFRender } from "./multipleMediaView";
import { ViewMediaPopup } from "./ViewMediaPopup";

const MediaSharing = props => {
  const { selectedMedia, altText, className = "", direction } = props;
  const [isModalOpen, setIsModalOpen] = useState({ visible: false });
  const [videoThumbnails, setVideoThumbnails] = useState([]);
  const [pdfModal, setpdfModal] = useState({
    visible: false,
    pdfUrl: "",
    mediaType: "",
  });

  const handleMediaUI = mediaInfo => {
    if (mediaInfo?.mediaType?.includes("image")) {
      const mediaUrl = mediaInfo?.thumbnailUrl || mediaInfo?.mediaUrl || "";
      // KLIPY-sourced GIFs require a watermark on the shared content
      // (https://docs.klipy.com/attribution). Klipy assets are served from
      // static.klipy.com, so match on the host.
      const isKlipyGif = (selectedMedia?.mediaUrl || "").includes("klipy");
      return (
        <div className="relative">
          <Image
            className={`${className} cursor-pointer w-full h-auto max-h-[300px] object-cover rounded `}
            src={heicToJpg(selectedMedia.compressedMediaUrl || selectedMedia.mediaUrl)}
            alt={altText}
            loading="lazy"
            placeholder={<Skeleton.Image active className="w-full h-[200px]" />}
          />
          {isKlipyGif && (
            <img
              src={KlipyWatermark}
              alt="KLIPY"
              className="absolute bottom-1 right-1 h-[16px] pointer-events-none z-10"
            />
          )}
          {/* <AntdIconV4
            onClick={() =>
              mediaInfo.mediaUrl
                ? mediaDownloader(mediaInfo.mediaUrl, mediaInfo?.mediaType?.split("/")[1])
                : console.log("Media url not found")
            }
            type="DownloadOutlined"
            className="bg-[#000] text-white right-[15px] top-[15px] text-[31px] absolute rounded-[5px]"
          /> */}
        </div>
      );
      // eslint-disable-next-line no-else-return
    } else if (mediaInfo?.mediaType?.includes("video")) {
      const mediaUrl = mediaInfo?.mediaUrl || "";
      return (
        <video
          className="cursor-pointer w-full h-auto max-h-[300px] max-w-full rounded"
          controls
          onClick={() =>
            setIsModalOpen({
              ...isModalOpen,
              visible: true,
              selectedMedia: mediaInfo,
            })
          }
          poster={selectedMedia.compressedThumbnail || selectedMedia?.thumbnailUrl || ""}
          // onClick={() => setIsModalOpen(true)}
        >
          <source src={mediaUrl} type="video/mp4" />
        </video>
      );
    } else if (mediaInfo?.mediaType?.includes("audio")) {
      return <AudioPlayer audioLink={mediaInfo?.mediaUrl} direction={direction} />;
    } else {
      return <PDFRender item={mediaInfo} index="pdf" />;
    }
  };

  return selectedMedia ? (
    <div
      className={`flex items-end ${
        direction === "TO_LEAD" ? "justify-end" : "justify-start"
      } p-0 w-full max-w-[300px] overflow-hidden`}
    >
      <Image.PreviewGroup
        preview={{
          toolbarRender: (
            _,
            {
              transform: { scale },
              actions: { onFlipY, onFlipX, onRotateLeft, onRotateRight, onZoomOut, onZoomIn },
              current,
            }
          ) => (
            <Space size={12} className="toolbar-wrapper">
              <DownloadOutlined
                onClick={() => {
                  mediaDownloader(selectedMedia.mediaUrl, selectedMedia?.mediaType?.split("/")[1]);
                }}
              />
              <SwapOutlined rotate={90} onClick={onFlipY} />
              <SwapOutlined onClick={onFlipX} />
              <RotateLeftOutlined onClick={onRotateLeft} />
              <RotateRightOutlined onClick={onRotateRight} />
              <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
              <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
            </Space>
          ),
        }}
      >
        {" "}
        {handleMediaUI(selectedMedia)}
      </Image.PreviewGroup>
      {isModalOpen.visible && (
        <MediaViewer
          isModalOpen={isModalOpen.visible}
          handleCancel={() => setIsModalOpen({ visible: false })}
          media={selectedMedia}
          videoThumbnails={videoThumbnails}
        />
      )}
      {pdfModal.visible && <ViewMediaPopup pdfModal={pdfModal} setpdfModal={setpdfModal} />}
    </div>
  ) : null;
};

export default MediaSharing;

export const CustomImageToolbar = ({ selectedMedia, scale, actions }) => (
  <Space size={12} className="toolbar-wrapper">
    <Tooltip title="Download Image">
      <DownloadOutlined
        onClick={() =>
          mediaDownloader(selectedMedia?.mediaUrl, selectedMedia?.mediaType?.split("/")[1])
        }
      />
    </Tooltip>
    <SwapOutlined rotate={90} onClick={actions.onFlipY} />
    <SwapOutlined onClick={actions.onFlipX} />
    <RotateLeftOutlined onClick={actions.onRotateLeft} />
    <RotateRightOutlined onClick={actions.onRotateRight} />
    <ZoomOutOutlined disabled={scale === 1} onClick={actions.onZoomOut} />
    <ZoomInOutlined disabled={scale === 50} onClick={actions.onZoomIn} />
  </Space>
);
